import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-design-graphique',
  templateUrl: './design-graphique.component.html',
  styleUrls: ['./design-graphique.component.scss']
})
export class DesignGraphiqueComponent implements OnInit {

  currentYear = new Date().getFullYear();


  constructor() { }

  ngOnInit(): void {
  }
  
  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}